export const nonWebConferencingKinds = ['ask_invitee', 'custom']
export const webConferencingKinds = ['google_conference', 'microsoft_teams_conference', 'webex_conference', 'gotomeeting_conference']
